export enum IndividualReportsPrintPopupDataTest {
    RenderButton = 'individual-reports-header_render-button',
    CloseButton = 'individual-reports-header_close-button',
    TemplateSelect = 'individual-reports-header_template-select',
}
